export default __webpack_public_path__ + "static/media/ID_SCHOOL_STACY.62ccfad2.jpg";